export default __webpack_public_path__ + "static/media/upload-folder-lower-jaw.a4e50258.svg";